export default [
    {
        path: 'users',
        component: require('@/layouts/content/users').default,
        name: 'admin.users',
        redirect: to => {
            return {
                name: 'admin.users.index'
            }
        },
        children: [
            {
                path: 'permissions',
                name: 'admin.permissions.index',
                component: () => import('@/views/admin/permissions/permissions/index'),
                meta: {
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: 'permissions/create',
                name: 'admin.permissions.create',
                component: () => import('@/views/admin/permissions/permissions/form'),
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: 'permissions/:id',
                name: 'admin.permissions.edit',
                component: () => import('@/views/admin/permissions/permissions/form'),
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: 'roles',
                name: 'admin.roles.index',
                component: () => import('@/views/admin/permissions/roles/index'),
                meta: {
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: 'roles/create',
                name: 'admin.roles.create',
                component: () => import('@/views/admin/permissions/roles/form'),
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: 'roles/:id',
                name: 'admin.roles.edit',
                component: () => import('@/views/admin/permissions/roles/form'),
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-permissions']
                    }
                }
            },
            {
                path: '/',
                name: 'admin.users.index',
                component: require('@/views/admin/users/index').default,
                meta: {
                    auth: {
                        roles: ['manage-users']
                    }
                }
            },
            {
                path: 'create',
                name: 'admin.users.create',
                component: require('@/views/admin/users/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-users']
                    }
                }
            },

            {
                path: ':id',
                name: 'admin.users.edit',
                component: require('@/views/admin/users/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-users']
                    }
                }
            },
        ]
    }
]